import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'


const _hoisted_1 = {
  class: "flex gap-x-4 rounded-xl p-3 bg-green-lp-500 border border-green-lp-100 items-baseline",
  style: { width: '417px' }
}
const _hoisted_2 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-4 w-4",
  alt: "close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.data.title)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_Icons, {
              name: "check-circle",
              class: "w-5 text-green-lp-100"
            }),
            _createVNode("div", {
              class: "text-sm font-semibold text-black-lp-100",
              innerHTML: _ctx.data.title
            }, null, 8, ["innerHTML"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: "text-sm font-medium text-black-lp-100",
        innerHTML: _ctx.data.message
      }, null, 8, ["innerHTML"])
    ]),
    _createVNode("button", {
      type: "button",
      class: "flex-shrink-0 p-1 transition-opacity hover:opacity-70",
      "aria-label": "Tutup",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }, [
      _hoisted_4
    ])
  ]))
}